import type { ThemeProps } from "models/styles/theme";
import styled from "styled-components/macro";
import { Heading2, Heading3 } from "styles/elements/Headings";
import { calculateRem } from "styles/mixins/calculateRem";

export const StyledNewUserPage = styled.div`
  margin-right: 32px;
  width: 100%;
`;

export const StyledNewUser = styled.div<ThemeProps>`
  border: 1px solid ${({ theme }: ThemeProps) => theme.palette.neutral._900};
  margin: ${calculateRem(44)} 0 ${calculateRem(72)};
  padding: ${calculateRem(32)} ${calculateRem(60)};
  width: 100%;

  ${Heading2} {
    font-weight: ${({ theme }: ThemeProps) => theme.font.weight.bold};
  }

  ${Heading3} {
    font-weight: ${({ theme }: ThemeProps) => theme.font.weight.bold};
    margin-top: ${calculateRem(64)};
  }
`;

export const StyledUserBasicInfo = styled.div<ThemeProps>`
  display: flex;
  flex-direction: column;
`;
